// extracted by mini-css-extract-plugin
export var menuIcon = "_qa-0";
export var menuIconInline = "_qa-1";